var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_31",
    "data-name": "Grupo 31",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.829,
    height: 23.506,
    viewBox: "0 0 56.829 23.506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_914",
    "data-name": "Trazado 914",
    d: "M35.52,14.108a9.4,9.4,0,1,1,9.395,9.4A9.392,9.392,0,0,1,35.52,14.108Zm14.632,0a5.241,5.241,0,1,0-10.473,0v.031a5.244,5.244,0,1,0,10.473-.031Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_915",
    "data-name": "Trazado 915",
    d: "M54.5,6.966a2.327,2.327,0,1,0-2.327-2.327A2.327,2.327,0,0,0,54.5,6.966Z",
    transform: "translate(0 0)",
    fill: "#00e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_916",
    "data-name": "Trazado 916",
    d: "M32.021,19.523a8.572,8.572,0,0,1-1.24.12c-2.034,0-3.48-1.14-3.48-3.3v-7.3h4.774a.37.37,0,0,0,.37-.369V5.569a.37.37,0,0,0-.37-.369H27.3V.4c0-.215-.123-.431-.524-.37-.924.154-2.218.37-3.235.524a.475.475,0,0,0-.4.492V5.2H18.913V.37A.355.355,0,0,0,18.544,0H15.125a.355.355,0,0,0-.37.37V6.562a9.123,9.123,0,0,0-5.3-1.755A9.426,9.426,0,0,0,0,14.108a9.466,9.466,0,0,0,9.457,9.4c3.644-.014,9.566-2.489,9.456-9.339V9.045h4.229v7.487c0,3.635,2.526,6.9,7.238,6.9a10.014,10.014,0,0,0,1.772-.151.367.367,0,0,0,.3-.363V19.888a.369.369,0,0,0-.431-.364ZM14.755,14.108a5.473,5.473,0,0,1-5.3,5.545,5.5,5.5,0,0,1,0-11,5.445,5.445,0,0,1,5.3,5.422Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDto);
export default __webpack_public_path__ + "static/media/dto.614e8f1dcffaab580bbcd3d19a6d3cfb.svg";
export { ForwardRef as ReactComponent };